"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextareaInput = void 0;
const react_1 = __importDefault(require("react"));
require("./styles.scss");
const TextareaInput = (props) => {
    const { label, rows = 3, value, disabled = false, onChangeValue, error, placeholder } = props;
    const changeHandler = (event) => onChangeValue(event.target.value);
    return (react_1.default.createElement("label", { className: "c-textarea-input-label" },
        react_1.default.createElement("div", null, label),
        react_1.default.createElement("textarea", { rows: rows, className: "c-textarea-input", disabled: disabled, onChange: changeHandler, value: value, placeholder: placeholder }),
        react_1.default.createElement("div", { className: "c-textarea-input-error" }, error)));
};
exports.TextareaInput = TextareaInput;
